export const CHANGE_SEARCHFIELD = "CHANGE_SEARCHFIELD";
export const CREATE_USER_PROFILE_SUCCESS = "CREATE_USER_PROFILE_SUCCESS";
export const CREATE_USER_PROFILE_FAILED = "CREATE_USER_PROFILE_FAILED";
export const CREATE_USER_PROFILE_PENDING = "CREATE_USER_PROFILE_PENDING";
export const REQUEST_USERS_PENDING = "REQUEST_USERS_PENDING";
export const REQUEST_USERS_SUCCESS = "REQUEST_USERS_SUCCESS";
export const REQUEST_USERS_FAILED = "REQUEST_USERS_FAILED";
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const GET_USER_PROFILE_ERROR = "GET_USER_PROFILE_ERROR";
export const EDIT_USER_PROFILE_SUCCESS = "EDIT_USER_PROFILE_SUCCESS";
